import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsTermOptions({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M4.2.5c.17 0 .3.13.3.3V2h5V.8c0-.17.13-.3.3-.3h.9c.17 0 .3.13.3.3V2h.5c.83 0 1.5.67 1.5 1.5v3.73A5 5 0 006.6 13H2.5A1.5 1.5 0 011 11.5v-8C1 2.67 1.67 2 2.5 2H3V.8c0-.17.13-.3.3-.3h.9zM1 6.2h12V5H1v1.2zM11.5 16a4 4 0 100-8 4 4 0 000 8zm.65-4.33v-1.45a.65.65 0 10-1.3 0V12c0 .2.1.4.27.53l1.46 1.06a.65.65 0 10.76-1.05l-1.19-.87z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsTermOptions.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsTermOptions.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsTermOptions svgRef={ref} {...props} />
));
export default ForwardRef;
